<template>
    <form method="post" action="https://syb.allinpay.com/apiweb/h5unionpay/unionorder">
        <ul class="product">
            <li class="product-item" :key="index" v-for="(row, index) in productData.list">
                <img :src="'https://img.hemutx.com/' + row.product.pic" />
                <div class="product-info">
                    <h4>{{ row.product.name }}</h4>
                    <p class="product-desc">{{ row.product.barcode }}</p>
                    <div class="product-desc">
                        <span class="product-price">{{ row.price | $separator }}</span>
                        <span class="product-num">x {{ row.num }}</span>
                    </div>
                </div>
            </li>
        </ul>
        <van-cell-group>
            <van-cell title="应收款" :value="productData.should | $separator" />
            <van-cell title="实收款" :value="productData.actually | $separator" />
            <van-field
                v-model="productData.trxamt"
                type="number"
                label="付款金额"
                placeholder="¥ 0.00"
                :rules="[{ required: true, message: '填写付款金额' }]"
                @input="onAllinpay"
            />
        </van-cell-group>
        <div style="margin: 16px">
            <input type="hidden" name="appid" :value="payData.appid" />
            <input type="hidden" name="body" :value="payData.body" />
            <input type="hidden" name="charset" :value="payData.charset" />
            <input type="hidden" name="cusid" :value="payData.cusid" />
            <input type="hidden" name="notify_url" :value="payData.notify_url" />
            <input type="hidden" name="randomstr" :value="payData.randomstr" />
            <input type="hidden" name="remark" :value="payData.remark" />
            <input type="hidden" name="reqsn" :value="payData.reqsn" />
            <input type="hidden" name="returl" :value="payData.returl" />
            <input type="hidden" name="sign" :value="payData.sign" />
            <input type="hidden" name="version" :value="payData.version" />
            <input type="hidden" name="trxamt" :value="payData.trxamt" />
            <template v-if="$route.query.code">
                <van-button
                    block
                    type="primary"
                    native-type="button"
                    @click="onPayment"
                    :disabled="button.disabled || productData.trxamt <= 0"
                    >微信支付</van-button
                >
            </template>
            <template v-else>
                <van-button block type="info" native-type="submit" :disabled="button.disabled || !productData.trxamt"
                    >通联支付</van-button
                >
            </template>
        </div>
    </form>
</template>

<script>
import { CellGroup, Cell, Field, Button, Toast } from 'vant'
export default {
    data() {
        return {
            productData: {
                list: [],
                should: 0,
                actually: 0,
                trxamt: 0,
                button: false
            },
            payData: {},
            button: {
                disabled: false
            }
        }
    },
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'van-field': Field,
        'van-button': Button
    },
    created() {
        this.$nextTick(() => {
            if (this.$route.query.order_id) {
                this.$request({
                    url: 'https://pay.hemutx.com/order/' + this.$route.query.order_id
                }).then(result => {
                    if (!result.status) {
                        if (result.data.order_details) {
                            this.productData.list = result.data.order_details
                        }
                        this.productData.should = result.data.should
                        this.productData.actually = result.data.actually
                        this.productData.trxamt = (result.data.should - result.data.actually).toFixed(2)

                        this.onAllinpay()
                    } else {
                        Toast(result.message || '操作失败')
                    }
                })
            }
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        onAllinpay() {
            // 支付信息
            if (!this.$route.query.code && this.productData.trxamt > 0) {
                this.button.disabled = true
                this.$request({
                    url: 'https://pay.hemutx.com/allinpay',
                    params: {
                        order_id: this.$route.query.order_id,
                        trxamt: this.productData.trxamt
                    }
                }).then(result => {
                    if (!result.status) {
                        this.payData = result.data
                        this.button.disabled = false
                    } else {
                        Toast.error(result.message || '操作失败')
                    }
                })
            }
        },
        onPayment() {
            var reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
            if (!reg.test(this.productData.trxamt)) {
                Toast('付款金额不正确')
            } else {
                if (this.$route.query.code) {
                    this.$request({
                        url: 'https://pay.hemutx.com/wxpay',
                        params: {
                            code: this.$route.query.code,
                            order_id: this.$route.query.order_id,
                            total: this.productData.trxamt * 100
                        }
                    }).then(result => {
                        if (!result.status) {
                            this.paymentData = result.data
                            if (typeof WeixinJSBridge == 'undefined') {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
                                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
                                }
                            } else {
                                this.onBridgeReady()
                            }
                        } else {
                            Toast(result.message || '操作失败')
                        }
                    })
                } else {
                    Toast('请重新获取二维码')
                }
            }
        },
        onBridgeReady() {
            WeixinJSBridge.invoke('getBrandWCPayRequest', this.paymentData, res => {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    Toast.success('支付成功')
                } else {
                    Toast.fail('支付失败')
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.product {
    padding-bottom: 16px;
    background: #fff;
    &-item {
        display: flex;
        padding: 16px 16px 0;
        &:first-child {
            margin-bottom: 0;
        }
    }
    &-info {
        flex: 1;
    }
    &-desc {
        display: flex;
        color: #646566;
        &:last-child {
            margin-top: 27px;
        }
    }
    &-price {
        flex: 1;
        font-weight: bold;
        color: #323233;
    }
    img {
        margin-right: 10px;
        height: 80px;
        border-radius: 4px;
    }
    h4 {
        margin: 0;
        font-size: 14px;
    }
}
</style>
